<div *ngIf="!isLoading"class="add-address-container">
    
    <!-- PAGE HEADER -->
    <div class="page-header">
        <div class="header-row">
            <!-- Local Breadcrumb removed to keep global one -->
            
            <!-- Header Actions -->
            <div class="header-actions" *ngIf="url == '/admin/address/add'">
                <button class="btn-back" (click)="cancel()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
                Go Back
            </button>
            </div>
        </div>
    </div>
    
    <!-- MAIN CONTENT - SPLIT SCREEN -->
    <div class="main-content">
        
        <!-- LEFT PANEL - FORM -->
        <div class="form-panel">
            <form [formGroup]="addressForm" (ngSubmit)="onSubmit()" class="address-form-layout">
                
                <!-- Address Search (Autocomplete) -->
                <div class="autocomplete-section">
                    <div class="form-group">
                        <label class="form-label required">Search Address</label>
                        <div class="autocomplete-container">
                            <input 
                                type="text" 
                                class="form-input" 
                                formControlName="addressSearch"
                                placeholder="Type to search for an address..."
                                autocomplete="off"
                                (focus)="onSearchFocus()"
                                (blur)="hideAutocomplete()">
                            
                            <!-- Autocomplete Dropdown -->
                            <div  class="autocomplete-dropdown" [class.show]="showAutocomplete">
                                <div 
                                    *ngFor="let suggestion of addressSuggestions" 
                                    class="autocomplete-item"
                                    (click)="selectAddressFromAutocomplete(suggestion)">
                                    <svg class="autocomplete-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                    </svg>
                                    <div class="autocomplete-text">
                                        <div class="autocomplete-title">{{ suggestion.title }}</div>
                                        <div class="autocomplete-subtitle">{{ suggestion.subtitle }}</div>
                                    </div>
                                </div>
                                
                                <!-- No Results -->
                                <div *ngIf="addressSuggestions.length === 0" class="autocomplete-item" style="cursor: default; color: #9ca3af;">
                                    <svg class="autocomplete-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                    </svg>
                                    <div class="autocomplete-text">
                                        <div class="autocomplete-title">No results found</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="form-help">Start typing to see address suggestions</span>
                    </div>
                </div>

                <div class="form-scroll">
                    <!-- Address Preview -->
                    <div class="address-preview" [class.show]="hasSelectedAddress">
                        <div class="preview-header">
                            <div class="preview-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="preview-title">Selected Address</div>
                        </div>
                        <div class="preview-address">{{ selectedAddress || '-' }}</div>
                        <div class="preview-coordinates">
                            <div>
                                <strong>Lat:</strong> <span class="preview-coord">{{ formatCoordinate(selectedLatitude) }}</span>
                            </div>
                            <div>
                                <strong>Lng:</strong> <span class="preview-coord">{{ formatCoordinate(selectedLongitude) }}</span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Manual Coordinate Entry -->
                    <div *ngIf="manualEntryEnabled" class="manual-coordinates">
                        <div class="coordinate-group">
                            <div class="form-group">
                                <label class="form-label">Latitude</label>
                                <input 
                                    type="number" 
                                    step="0.000001"
                                    class="form-input coordinate-input" 
                                    formControlName="latitude"
                                    (input)="onManualCoordinateChange()">
                                <span class="form-help">Decimal degrees</span>
                            </div>
                            
                            <div class="form-group">
                                <label class="form-label">Longitude</label>
                                <input 
                                    type="number" 
                                    step="0.000001"
                                    class="form-input coordinate-input" 
                                    formControlName="longitude"
                                    (input)="onManualCoordinateChange()">
                                <span class="form-help">Decimal degrees</span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Full Address (Only shown when manual entry enabled) -->
                    <div class="form-group" *ngIf="manualEntryEnabled">
                        <label class="form-label required">Full Address</label>
                        <input 
                            type="text" 
                            class="form-input" 
                            formControlName="fullAddress"
                            placeholder="e.g., 209 Steeles Avenue West, Brampton, ON, Canada">
                        <span class="form-help">This will be used for delivery reference</span>
                    </div>
                </div>

            </form>
            
            <!-- Form Footer -->
            <div class="form-footer">
                <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
                <button *ngIf="!isEditMode" type="submit" class="btn-submit" (click)="onSubmit()" [disabled]="addressForm.invalid">
                  <ng-container *ngIf="!isSubmitting; else loading">
           Add Address
          </ng-container>

          <ng-template #loading>
           <span  class="loading-spinner"></span>
          </ng-template>
                </button>
                     <button *ngIf ="isEditMode" type="submit" class="btn-submit" (click)="onSubmit()" [disabled]="addressForm.invalid">
                  <ng-container *ngIf="!isSubmitting; else loading">
           Edit Address
          </ng-container>

          <ng-template #loading>
           <span  class="loading-spinner"></span>
          </ng-template>
                </button>
            </div>
        </div>
        
        <!-- RIGHT PANEL - MAP -->
        <div class="map-panel">
            <!-- Map Placeholder -->
            <div class="map-placeholder" *ngIf="!showMap">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
                </svg>
                <div class="map-placeholder-text">Select an address to view on map</div>
            </div>
            
            <!-- Map Container -->
            <div class="map-container">
                <!-- <iframe 
                    *ngIf="showMap"
                    [src]="mapUrl"
                    width="100%" 
                    height="100%" 
                    frameborder="0" 
                    style="border:0"
                    referrerpolicy="no-referrer-when-downgrade"
                    allowfullscreen>
                </iframe> -->
                <div id="map"style="width:100%; height:100%;"></div>

                <!-- Marker Overlay -->
                <!-- <div class="map-marker">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#00a862">
                        <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                    </svg>
                </div> -->
            </div>
        </div>
        
    </div>
    
</div>
<div class="loader-overlay" *ngIf="isLoading">
  <div class="spinners"></div>
</div>